import React from 'react'

const CronSyntaxLink: React.FC = () => {
  return <a href='https://www.freeformatter.com/cron-expression-generator-quartz.html' rel='noopener noreferrer' target='_blank'>(CRON syntax)</a>
}

export default CronSyntaxLink